import { createAsyncThunk } from '@reduxjs/toolkit';
import labApi from '../../core/api/lab.api';
import { ResetStagedShipmentResponse } from '../../core/api/lab.types';

/* Create new CryoBox */
export const resetStagedShipmentThunk = createAsyncThunk(
  'shipment/resetStagedShipment',
  async (_, { rejectWithValue }: any) => {
    const response: ResetStagedShipmentResponse = await labApi.resetStagedShipment();
    if (response.data?.resetStagedShipment) {
      return response.data?.resetStagedShipment;
    }
    return rejectWithValue(response.errors);
  },
);
